const STORAGE_KEY = 'substitutionGestureHelp:v1'
const LONG_PRESS_ACTIVATIONS_TO_RETIRE = 3

// This transition aid is deliberately short-lived. Remove its UI and storage
// code after this date rather than extending the deadline.
export const SUBSTITUTION_GESTURE_HELP_EXPIRES = Date.parse('2026-12-16T00:00:00+11:00')

type SubstitutionGestureHelpState = {
	longPressActivations: number
}

function loadState(): SubstitutionGestureHelpState {
	try {
		const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null') as Partial<SubstitutionGestureHelpState> | null
		const longPressActivations = value?.longPressActivations
		return {
			longPressActivations: Number.isInteger(longPressActivations) ? Math.max(0, longPressActivations as number) : 0,
		}
	} catch (error) {
		console.error('Unable to read substitution gesture help state.', error)
		return { longPressActivations: 0 }
	}
}

export function shouldShowSubstitutionGestureHelp(now = Date.now()) {
	return now < SUBSTITUTION_GESTURE_HELP_EXPIRES && loadState().longPressActivations < LONG_PRESS_ACTIVATIONS_TO_RETIRE
}

export function recordLongPressSubstitutionActivation(now = Date.now()) {
	if (now >= SUBSTITUTION_GESTURE_HELP_EXPIRES) {
		return
	}

	const state = loadState()
	state.longPressActivations = Math.min(LONG_PRESS_ACTIVATIONS_TO_RETIRE, state.longPressActivations + 1)
	try {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
	} catch (error) {
		console.error('Unable to save substitution gesture help state.', error)
	}
}

export function canUseLegacySubstitutionGesture(
	index: RosterPositionIndex,
	best: Best,
	numPeriods: NumPeriods,
	numFieldPositions: number,
) {
	if (!best.roster.length || !numPeriods) {
		return false
	}

	if (best.subs?.includes(index)) {
		return true
	}

	const playersPerPeriod = best.roster.length / numPeriods
	const periodStart = Math.floor(index / playersPerPeriod) * playersPerPeriod
	return index < periodStart + numFieldPositions
}
